<template>
    <div class="input-group date">
        <input type="text" class="form-control" @blur="setValue" />
        <div class="input-group-addon">
            <span class="glyphicon glyphicon-th"></span>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery';
    import moment from 'moment';
    import datepicker from 'bootstrap-datepicker'
    import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css'

    export default {
        props: ['value'],
        data: function () {
            return {
                dateField: null
            }
        },
        watch: {
            controller: function (newValue) {
                //console.log("Date Changed to ", newValue)
                var formattedDate = moment(newValue.value).format('DD/MM/YYYY');
                this.dateField.datepicker('setDate', formattedDate)
            },
            value: function (newValue) {
                var newDate = this.dateField.datepicker('getDate')
                if (moment(newValue).diff(newDate) != 0) {
                    var formattedDate = moment(newValue).format('DD/MM/YYYY');
                    this.dateField.datepicker('setDate', formattedDate)
                }
            }
        },
        mounted: function () {
            this.dateField = $(this.$el);
            var that = this;

            this.dateField.datepicker({
                format: "dd-M-yyyy",
                keepEmptyValues: true,
                autoclose: true
            }).on('changeDate', function (e) {
                    var newDate = that.dateField.datepicker('getDate')
                    that.$emit('input', newDate)
                    //that.value = that.dateField.datepicker('getDate')
                    //console.log("Changing value of datepicker to ", that.controller.value )
                });

            if (this.value && this.value != null) {
                //console.log("Setting date to ", this.controller.value)
                this.dateField.datepicker('setDate', this.value)
            }

        },
        methods: {
            setValue: function () {
                var newDate = this.dateField.datepicker('getDate')
                this.$emit('input', newDate)
            }
        }
    }

</script>


// WEBPACK FOOTER //
// simpledatepicker.scp.html?6084734f